module.exports = window.__loadPromiseRequirejs__("@wix/wix-ui-santa/viewerComponentService.bundle.min");